import { ChangeDetectionStrategy, Component } from '@angular/core';
import { StepperComponent } from './stepper/stepper.component';
import { TranslateModule } from '@ngx-translate/core';

@Component({
  selector: 'app-platform-banner',
  standalone: true,
  imports: [StepperComponent, TranslateModule],
  templateUrl: './platform-banner.component.html',
  styleUrl: './platform-banner.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PlatformBannerComponent {}
